import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { AsyncQueryRequest, BuildHeader } from 'src/Utils/headerBuilder'
import { RequestMethods } from '../Helper/FetchHelpers'

const apiController = '/Contract/'

export const InitiateContractSigning = createAsyncThunk('InitiateContractSigning', async (query) =>
  AsyncQueryRequest(apiController + 'signing/initiate', query, RequestMethods.POST),
)

export const CancelContractSigning = createAsyncThunk('CancelContractSigning', async (query) =>
  AsyncQueryRequest(apiController + 'signing/cancel', query, RequestMethods.PUT),
)

export const FetchSigningStatus = createAsyncThunk('FetchSigningStatus', async (contractId) => {
  const response = await fetch(
    window.extended.MYAPP_API_ENDPOINT + apiController + `signing/status/${contractId}`,
    {
      method: RequestMethods.GET,
      headers: BuildHeader(),
    },
  )
  return response.json()
})

export const ResendSigningLink = createAsyncThunk('ResendSigningLink', async (query) =>
  AsyncQueryRequest(apiController + 'signing/resend', query, RequestMethods.POST),
)

const initialState = {
  signingStatus: null,
  loading: false,
  error: null,
}

const contractSigningSlice = createSlice({
  name: 'contractSigning',
  initialState,
  reducers: {
    clearSigningStatus: (state) => {
      state.signingStatus = null
      state.error = null
    },
  },
  extraReducers: {
    [InitiateContractSigning.pending]: (state) => {
      state.loading = true
      state.error = null
    },
    [InitiateContractSigning.fulfilled]: (state, action) => {
      state.loading = false
      state.signingStatus = action.payload
    },
    [InitiateContractSigning.rejected]: (state, action) => {
      state.loading = false
      state.error = action.error.message
    },

    [CancelContractSigning.pending]: (state) => {
      state.loading = true
      state.error = null
    },
    [CancelContractSigning.fulfilled]: (state) => {
      state.loading = false
      state.signingStatus = null
    },
    [CancelContractSigning.rejected]: (state, action) => {
      state.loading = false
      state.error = action.error.message
    },

    [FetchSigningStatus.pending]: (state) => {
      state.loading = true
    },
    [FetchSigningStatus.fulfilled]: (state, action) => {
      state.loading = false
      state.signingStatus = action.payload
    },
    [FetchSigningStatus.rejected]: (state, action) => {
      state.loading = false
      state.error = action.error.message
    },

    [ResendSigningLink.pending]: (state) => {
      state.loading = true
      state.error = null
    },
    [ResendSigningLink.fulfilled]: (state) => {
      state.loading = false
    },
    [ResendSigningLink.rejected]: (state, action) => {
      state.loading = false
      state.error = action.error.message
    },
  },
})

export const { clearSigningStatus } = contractSigningSlice.actions
export default contractSigningSlice.reducer
